import axios from 'axios'
import { TIMEOUT } from './constants'

const apiClient = axios.create({
  timeout: TIMEOUT,
})

export default apiClient
